function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameBoardSizerTemplate = require('./game-board-sizer.template');

/**
 * TODO - remove JQUERY
 * Adds a slider to screen to allow players to magnify or shrink the game board
 * Will check user's saved game preferences for the size of the board, or do some math to fill the screen (but not overflow) with the gameboard (can specify sizing target in attachEvents)
 * Included by default in gameTemplate as "sizer", must call render/attachEvents in individual game module to display and use it (preferably in initializeHTML function)
 */
var GameBoardSizer = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param app - the Saito application
   */
  function GameBoardSizer(app, mod) {
    _classCallCheck(this, GameBoardSizer);
    this.app = app;
    this.mod = mod;
    this.maxZoom = 200;
    this.zoomStep = 5;
    this.container = '.hamburger-container';
    this.boardWheelHandler = null;
    this.boardWheelTarget = null;
    this.saveScalePreferenceTimeout = null;
  }

  /**
   * Creates the gameBoardSizer if it does not already exist
   * @param selector - DOM reference for where to attach the gameBoardSizer, default = body
   */
  return _createClass(GameBoardSizer, [{
    key: "render",
    value: function render() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      try {
        if (!document.getElementById('game_board_sizer')) {
          if (selector) {
            this.app.browser.addElementToSelector(GameBoardSizerTemplate(this.maxZoom), selector);
          } else {
            this.app.browser.prependElementToSelector(GameBoardSizerTemplate(this.maxZoom), this.container);
          }
        }
      } catch (err) {
        console.error(err);
      }
    }

    /**
     * Adds event listener to slider and makes target draggable (via JQuery). Changes to the board size and position are saved for subsequent game loads
     * @param target - DOM reference to object to be scaled in size
     *
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#gameboard';
      var sizer_self = this;
      var targetObject = document.querySelector(target);
      if (!targetObject) {
        console.error(target + ' not found');
        return;
      }
      if (!this.rendered) {
        this.app.connection.on('browser-fullscreen-toggle', function () {
          try {
            centerBoard(document.querySelector('#game_board_sizer input'));
          } catch (err) {}
        });
        this.rendered = true;
      }
      var centerBoard = function centerBoard(input) {
        var topAdjustment = 0;
        var boardWidth = parseInt(window.getComputedStyle(targetObject).width) || 0;
        var boardHeight = parseInt(window.getComputedStyle(targetObject).height) || 0;
        if (window.getComputedStyle(targetObject).boxSizing == 'content-box') {
          boardWidth += parseInt(window.getComputedStyle(targetObject).paddingLeft) + parseInt(window.getComputedStyle(targetObject).paddingRight);
          boardHeight += parseInt(window.getComputedStyle(targetObject).paddingTop) + parseInt(window.getComputedStyle(targetObject).paddingBottom);
          topAdjustment += parseInt(window.getComputedStyle(targetObject).paddingTop);
        }
        boardWidth += parseInt(window.getComputedStyle(targetObject).marginLeft) + parseInt(window.getComputedStyle(targetObject).marginRight);
        boardHeight += parseInt(window.getComputedStyle(targetObject).marginTop) + parseInt(window.getComputedStyle(targetObject).marginBottom);
        topAdjustment += parseInt(window.getComputedStyle(targetObject).marginTop);
        var screenRatio = Math.min(window.innerWidth / boardWidth, window.innerHeight / boardHeight);
        input.value = Math.floor(100 * screenRatio);
        sizer_self.updateSliderProgress(input);
        targetObject.style.transformOrigin = 'top left';
        targetObject.style.transform = "scale(".concat(input.value / 100, ")");
        targetObject.style.left = '';
        targetObject.style.top = '';
        if (targetObject.getBoundingClientRect().width < window.innerWidth) {
          var offset = Math.round((window.innerWidth - targetObject.getBoundingClientRect().width) / 2) - 10;
          targetObject.style.left = offset + 'px';
        }
        if (targetObject.getBoundingClientRect().height < window.innerHeight) {
          var _offset = 0;
          if (window.innerHeight - targetObject.getBoundingClientRect().height >= 40) {
            _offset = Math.min(50, window.innerHeight - targetObject.getBoundingClientRect().height);
          } else {
            _offset = Math.round((window.innerHeight - targetObject.getBoundingClientRect().height) / 2) + 5;
          }
          _offset = Math.max(0, _offset - topAdjustment);
          targetObject.style.top = _offset + 'px';
        }
      };

      // adjust scale
      var boardScaler = document.querySelector('#game_board_sizer input');
      if (boardScaler) {
        try {
          if (sizer_self.mod.loadGamePreference(sizer_self.mod.returnSlug() + '-board-scale')) {
            boardScaler.value = sizer_self.mod.loadGamePreference(sizer_self.mod.returnSlug() + '-board-scale');
            sizer_self.scaleBoard(targetObject);
          } else {
            setTimeout(centerBoard, 250, boardScaler);
          }
        } catch (err) {
          sizer_self.mod.deleteGamePreference(sizer_self.mod.returnSlug() + '-board-scale');
          console.error(err);
        }
        sizer_self.updateSliderProgress(boardScaler);
        boardScaler.oninput = function () {
          sizer_self.scaleBoard(targetObject, false);
        };
        boardScaler.onchange = function () {
          sizer_self.scaleBoard(targetObject);
        };
        if (sizer_self.boardWheelTarget && sizer_self.boardWheelHandler) {
          sizer_self.boardWheelTarget.removeEventListener('wheel', sizer_self.boardWheelHandler);
        }
        sizer_self.boardWheelTarget = targetObject;
        sizer_self.boardWheelHandler = function (event) {
          if (event.target !== targetObject) {
            return;
          }
          if (event.deltaY === 0) {
            return;
          }
          var scrollDirection = event.deltaY < 0 ? 1 : -1;
          var minZoom = parseInt(boardScaler.min, 10) || 2;
          var maxZoom = parseInt(boardScaler.max, 10) || sizer_self.maxZoom;
          var currentZoom = parseInt(boardScaler.value, 10);
          var nextZoom = currentZoom + scrollDirection * sizer_self.zoomStep;
          nextZoom = Math.max(minZoom, Math.min(maxZoom, nextZoom));
          if (nextZoom === currentZoom) {
            return;
          }
          event.preventDefault();
          boardScaler.value = nextZoom;
          sizer_self.scaleBoard(targetObject, false);
          sizer_self.saveScalePreference(boardScaler.value, 250);
        };
        targetObject.addEventListener('wheel', sizer_self.boardWheelHandler, {
          passive: false
        });
        document.querySelectorAll('#game_board_sizer .game-board-sizer-step').forEach(function (button) {
          button.onclick = function () {
            var zoomDirection = parseInt(button.dataset.boardZoom, 10);
            var minZoom = parseInt(boardScaler.min, 10) || 2;
            var maxZoom = parseInt(boardScaler.max, 10) || sizer_self.maxZoom;
            var currentZoom = parseInt(boardScaler.value, 10);
            var nextZoom = currentZoom + zoomDirection * sizer_self.zoomStep;
            nextZoom = Math.max(minZoom, Math.min(maxZoom, nextZoom));
            if (nextZoom === currentZoom) {
              return;
            }
            boardScaler.value = nextZoom;
            sizer_self.scaleBoard(targetObject);
          };
        });
      }
      $('#game_board_sizer .game-board-sizer-center').off();
      $('#game_board_sizer .game-board-sizer-center').on('click', function () {
        centerBoard(document.querySelector('#game_board_sizer input'));
        sizer_self.saveScalePreference(document.querySelector('#game_board_sizer input').value);
      });

      // and adjust positioning
      try {
        var boardoffset = sizer_self.mod.loadGamePreference(sizer_self.mod.returnSlug() + '-board-offset');
        if (boardoffset) {
          $(target).offset(boardoffset);
        }
      } catch (err) {
        sizer_self.mod.deleteGamePreference(sizer_self.mod.returnSlug() + '-board-offset');
        console.error(err);
      }

      // and make draggable
      $(target).draggable({
        stop: function stop(event, ui) {
          sizer_self.mod.saveGamePreference(sizer_self.mod.returnSlug() + '-board-offset', ui.offset);
        }
      });
    }

    /**
     * Internal function to scale targetObject based on slider
     * @param targetObject - by default, the "#gameboard" DOM object
     *
     */
  }, {
    key: "scaleBoard",
    value: function scaleBoard(targetObject) {
      var savePreference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var boardScaler = document.querySelector('#game_board_sizer input');
      this.updateSliderProgress(boardScaler);
      targetObject.style.transform = "scale(".concat(boardScaler.value / 100, ")");
      if (savePreference) {
        this.saveScalePreference(boardScaler.value);
      }
    }
  }, {
    key: "updateSliderProgress",
    value: function updateSliderProgress(input) {
      if (!input) {
        return;
      }
      var minZoom = parseFloat(input.min) || 0;
      var maxZoom = parseFloat(input.max) || this.maxZoom;
      var currentZoom = parseFloat(input.value) || minZoom;
      var progress = (currentZoom - minZoom) / (maxZoom - minZoom) * 100;
      input.style.setProperty('--board-scale-progress', "".concat(Math.max(0, Math.min(100, progress)), "%"));
    }
  }, {
    key: "saveScalePreference",
    value: function saveScalePreference(value) {
      var _this = this;
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      clearTimeout(this.saveScalePreferenceTimeout);
      this.saveScalePreferenceTimeout = setTimeout(function () {
        _this.mod.saveGamePreference(_this.mod.returnSlug() + '-board-scale', value);
      }, delay);
    }
  }]);
}();
module.exports = GameBoardSizer;